import { useTranslation } from 'react-i18next';
import { useCartHandlers } from 'hooks/cart/useCartHandlers';
import * as Styled from './styles';
import { CartClose } from '../CartClose';
import { useAppSelector } from 'appRedux/hooks';

export const CartHeader = () => {
  const { t } = useTranslation();
  const { handleEmptyCart } = useCartHandlers();
  const {
    info: { items_count }
  } = useAppSelector(({ cart }) => cart);

  return (
    <Styled.CartHeader>
      <Styled.CartHeaderTitle>
        {t('cart.title', { count: items_count })}
      </Styled.CartHeaderTitle>
      {!!items_count && (
        <Styled.CartHeaderClear onClick={handleEmptyCart}>
          {t('cart.clearCart')}
        </Styled.CartHeaderClear>
      )}
      <CartClose />
    </Styled.CartHeader>
  );
};
